import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  OutlinedInput,
  Snackbar,
} from "@mui/material";
import { FC, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useMutation } from "react-query";

interface Props {
  open: boolean;
  onClose: () => void;
}

const ForgotPassword: FC<Props> = ({ open, onClose }) => {
  const [isOpenConfirmSnackbar, setIsOpenConfirmSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const mutation = useMutation({
    mutationFn: (data: Record<string, string>) =>
      fetch(`${process.env.REACT_APP_API_URL}/api/users/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // Set the content type to JSON
        },
        body: JSON.stringify(data),
      }),
  });

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          component: "form",
          onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const data = new FormData(event.currentTarget);
            if (data.get("email")) {
              const sendData = {
                email: data.get("email") as string,
              };
              mutation.mutateAsync(sendData).then((response) => {
                if (response.status === 200) {
                  setErrorMessage("");
                } else {
                  setErrorMessage("error");
                }
                setIsOpenConfirmSnackbar(true);
              });
            }
            onClose();
          },
          sx: (theme) => ({
            backgroundImage: "none",
            maxWidth: "none",
            margin: 0,
            maxHeight: "none",
            width: "30%",

            // ROADMAP mobile/tablet boundary (768): it was `down("md")` (900),
            // the legacy value the theme asks not to use in live code.
            [theme.breakpoints.down("tablet")]: {
              width: "90%",
            },
          }),
        }}
      >
        <DialogTitle>Réinitialiser le mot de passe</DialogTitle>
        <DialogContent
          sx={{ display: "flex", flexDirection: "column", gap: 2 }}
        >
          <DialogContentText>
            Saisissez l&apos;identifiant de votre compte et nous vous enverrons
            un lien pour réinitialiser votre mot de passe.
          </DialogContentText>
          <OutlinedInput
            autoFocus
            required
            margin="dense"
            id="email"
            name="email"
            placeholder="Adresse email"
            type="email"
            fullWidth
          />
        </DialogContent>
        <DialogActions sx={{ pb: 3, px: 3 }}>
          <Button onClick={onClose}>Annuler</Button>
          <Button variant="contained" type="submit">
            Continuer
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "white",
            color: errorMessage ? "red" : "green",
          },
        }}
        open={isOpenConfirmSnackbar}
        autoHideDuration={6000}
        onClose={() => {
          setIsOpenConfirmSnackbar(false);
        }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => {
              setIsOpenConfirmSnackbar(false);
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        message={
          errorMessage
            ? "Une erreur s'est produite lors de l'envoi du mail."
            : "Le mail a été envoyé avec succès."
        }
      />
    </>
  );
};

export default ForgotPassword;
